import React from "react";
import Loader from "react-loader-spinner";

export default class Spinner extends React.Component {
  render() {
    return (
      <Loader
        className="text-center spinner-top-padding img-responsive"
        type="Oval"
        color="#212894"
        height={100}
        width={100}
        timeout={3000}
      />
    );
  }
}
